<!-- <iframe src="http://3.127.76.33:3000/d-solo/47fc49e3-1d3b-4637-952a-b797b3bf7896/new-dashboard?orgId=1&theme=light&timezone=browser&refresh=5s&panelId=1&__feature.dashboardSceneSolo" style="width: 100%; height: 500px" frameborder="0">
</iframe> -->

<mat-accordion>

  <ng-container *ngFor="let system of systems; let i = index;">
    <mat-expansion-panel [expanded]="i == 0" (opened)="system.expanded = true" (closed)="system.expanded = false"
      class="expansion-panel">
      <mat-expansion-panel-header>
        <mat-panel-title>{{system.number}} - {{ system.name }}</mat-panel-title>
        <mat-panel-description> {{ system.description }} </mat-panel-description>
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <!-- {{ system | json}} -->
        <!-- Tabs -->
        <mat-tab-group>
          <mat-tab label="System settings">
            <div class="flex-container">
              <mat-card class="example-card" appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Settings</mat-card-title>
                  <mat-card-subtitle>Adjustmenst for system</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div style="display: flex; flex-direction: row; gap: 32px; margin: 20px">
                    <div style="display: flex; flex-direction: column; gap: 8px;">
                      <div style="display: flex; flex-direction: column; gap: 8px;margin-top: 15px">
                        <mat-label style="font-weight: bold; margin-bottom: 8px;">System Turbo</mat-label>
                        <div style="display: flex; align-items: center; gap: 8px;">
                          <mat-slider min="0" max="5" step="0.1">
                            <input matSliderThumb [(ngModel)]="system.turbo">
                          </mat-slider>
                          <input matInput type="number" min="0" max="5" step="0.1" [(ngModel)]="system.turbo"
                            style="width: 60px; margin-left: 8px;" [value]="system.turbo?.toFixed(1)">
                          <input matInput disabled style="width: 60px; margin-left: 8px;"
                            [value]="toPercent(system.turbo)">
                        </div>
                      </div>
                      <hr />
                      <mat-label style="font-weight: bold; margin-bottom: 8px;">Disable system</mat-label>
                      <mat-checkbox class="checkbox" [(ngModel)]="system.disableSystem"
                        [checked]="system.disableSystem === true">System</mat-checkbox>
                      <hr />
                      <mat-label style="font-weight: bold; margin-bottom: 8px;">Disable food types</mat-label>
                      <mat-checkbox class="checkbox" [(ngModel)]="system.freshFood"
                        [checked]="system.freshFood === true">Fresh food</mat-checkbox>
                      <mat-checkbox class="checkbox" [(ngModel)]="system.drinks"
                        [checked]="system.drinks === true">Drinks</mat-checkbox>
                      <mat-checkbox class="checkbox" [(ngModel)]="system.snacks"
                        [checked]="system.snacks === true">Snacks</mat-checkbox>
                      <hr />
                      <mat-label style="font-weight: bold; margin-bottom: 8px;">Disable days</mat-label>
                      <ng-container *ngFor="let day of system.weekTurbo">
                        <mat-checkbox class="checkbox" [(ngModel)]="day.disabled">
                          {{ day.day }} ({{ day.disabled }})
                        </mat-checkbox>
                      </ng-container>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              <mat-card class="example-card" appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Week Turbo</mat-card-title>
                  <mat-card-subtitle>Adjust turbo for each week day</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <ng-container *ngFor="let day of system.weekTurbo; let j = index">
                    <label mat-label class="smal-label">{{ day.day }} Turbo</label>
                    <div style="display: flex; flex-direction: column; gap: 8px;">
                      <div style="display: flex; align-items: center; gap: 8px;">
                        <mat-slider min="0" max="3" step="0.05">
                          <input matSliderThumb [disabled]="day.disabled"
                            [(ngModel)]="day.turbo">
                        </mat-slider>
                        <input matInput type="number" min="0" max="3" step="0.05"
                          [disabled]="day.disabled" [(ngModel)]="day.turbo"
                          style="width: 60px; margin-left: 8px;" [value]="day.turbo?.toFixed(1)">
                        <input matInput disabled style="width: 60px; margin-left: 8px;"
                          [value]="toPercent(day.turbo)">
                      </div>
                    </div>
                  </ng-container>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-tab>

          <mat-tab label="Product Adjustments">
            <div class="flex-container">
              <mat-card class="example-card" appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Categories</mat-card-title>
                  <mat-card-subtitle>Adjust turbo for product categories</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content style="padding-top:16px">
                  <table mat-table [dataSource]="system.categories" class="mat-elevation-z1" style="width: 100%;">
                    <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef>Category</th>
                      <td mat-cell *matCellDef="let category">{{ category.name | titlecase }}</td>
                    </ng-container>
                    <ng-container matColumnDef="turbo">
                      <th mat-header-cell *matHeaderCellDef>Turbo</th>
                      <td mat-cell *matCellDef="let category">
                        <div style="display: flex; align-items: center; gap: 8px;">
                          <mat-slider min="0" max="5" step="0.05">
                            <input matSliderThumb [(ngModel)]="category.turbo">
                          </mat-slider>
                          <input matInput type="number" min="0" max="5" step="0.05" [(ngModel)]="category.turbo"
                            style="width: 60px; margin-left: 8px;" [value]="category.turbo?.toFixed(2)">
                          <input matInput disabled style="width: 60px; margin-left: 8px;"
                            [value]="toPercent(category.turbo)">
                        </div>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="['name', 'turbo']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['name', 'turbo'];"></tr>
                  </table>
                </mat-card-content>
              </mat-card>
              <mat-card class="example-card" appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Types</mat-card-title>
                  <mat-card-subtitle>Adjust turbo and minimums for product type</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content style="padding-top:16px">
                  <mat-accordion>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>Advanced</mat-panel-title>
                        <mat-panel-description></mat-panel-description>
                      </mat-expansion-panel-header>

                      <table mat-table [dataSource]="system.types" class="mat-elevation-z1" style="width: 100%;">
                        <ng-container matColumnDef="name">
                          <th mat-header-cell *matHeaderCellDef>Type</th>
                          <td mat-cell *matCellDef="let type">{{ type.name }}</td>
                        </ng-container>
                        <ng-container matColumnDef="turbo">
                          <th mat-header-cell *matHeaderCellDef>Turbo</th>
                          <td mat-cell *matCellDef="let type">
                            <div style="display: flex; align-items: center; gap: 8px;">
                              <mat-slider min="0" max="5" step="0.05">
                                <input matSliderThumb [(ngModel)]="type.turbo">
                              </mat-slider>
                              <input matInput type="number" min="0" max="5" step="0.05" [(ngModel)]="type.turbo"
                                style="width: 60px; margin-left: 8px;" [value]="type.turbo?.toFixed(2)">
                              <input matInput disabled style="width: 60px; margin-left: 8px;"
                                [value]="toPercent(type.turbo)">
                            </div>
                          </td>
                        </ng-container>
                        <!-- <ng-container matColumnDef="minimum">
                          <th mat-header-cell *matHeaderCellDef>Minimum</th>
                            <td mat-cell *matCellDef="let type">
                              <input matInput type="number" min="0" max="20" [(ngModel)]="type.minimum"
                                style="width: 80px; margin-left: 8px;" placeholder="Minimum">
                              <span style="margin-left: 16px; color: #888; font-size: 13px;">(Saved: {{ system.categoryMinimum?.[type.name] ?? '-' }})</span>
                            </td>
                        </ng-container> -->
                          <ng-container matColumnDef="categoryMinimum">
                            <th mat-header-cell *matHeaderCellDef>Category Minimum</th>
                            <td mat-cell *matCellDef="let type">
                              <mat-form-field appearance="fill" style="width: 120px;">
                                <mat-select [(ngModel)]="system.categoryMinimum[type.name]">
                                  <mat-option *ngFor="let min of [0,1,2,3,4,5,6,7,8,9,10,15,20]" [value]="min">{{min}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </td>
                          </ng-container>
                        <tr mat-header-row *matHeaderRowDef="['name', 'turbo', 'categoryMinimum']"></tr>
                          <tr mat-row *matRowDef="let row; columns: ['name', 'turbo', 'categoryMinimum'];"></tr>
                      </table>
                    </mat-expansion-panel>
                  </mat-accordion>
                </mat-card-content>
              </mat-card>


            </div>
          </mat-tab>
        </mat-tab-group>
        <button mat-raised-button color="primary" (click)="saveSystem(system)">Save</button>
      </ng-template>
    </mat-expansion-panel>
  </ng-container>
</mat-accordion>